<template>
  <detail-item
    :icon="iconToDisplay"
    :without-icon="withoutIcon"
    :large="large"
    :name-spacing="nameSpacing"
  >
    <template #name>
      <div class="flex justify-between items-center no-wrap full-width">
        <span class="text-ellipsis" :title="metadata.title">
          {{ metadata.title }}
        </span>
        <div v-if="metadata.color" class="q-ml-sm">
          <div
            class="dot"
            :style="{'background-color': metadata.color}"
          />
        </div>
      </div>
    </template>

    <div class="q-gutter-sm">
      <nl2br
        v-for="(value, key) in metadata.values"
        :key="key"
        tag="div"
        :text="value.value"
      />
    </div>
  </detail-item>
</template>

<script>
import { DEFAULT_ICON } from './../metadataMixin'

export default {
  props: {
    metadata: {
      type: Object,
      required: true
    },
    nameSpacing: {
      type: Number
    },
    large: {
      type: Boolean
    },
    withoutIcon: {
      type: Boolean
    }
  },
  computed: {
    iconToDisplay () {
      return this.metadata.icon || DEFAULT_ICON
    }
  }
}
</script>
